export default __webpack_public_path__ + "static/media/logo.d7ba5e68.svg";